<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="2">
          <v-toolbar flat elevation="4" color="grey lighten-3" class="mb-5">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-application-export</v-icon
              >
            </v-card>
            <div
              class="
                usuario
                text-uppercase
                ml-5
                font-weight-bold
                blue-grey--text
                text--darken-3
              "
            >
              Compras
            </div>
            <v-spacer></v-spacer>
            <!-- Ventana modal editar y guardar  -->
            <v-dialog
              v-model="dialog"
              persistent:overlay="false"
              max-width="60rem"
            >
              <v-card>
                <v-card-title class="nav">
                  <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
                    Ver Procesos
                  </span>
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout
                      v-for="(item, index) in editedItem.infoProceso"
                      :key="index"
                    >
                      <v-card class="mt-5" width="98%" elevation="4">
                        <v-layout wrap class="pl-7 pt-4 pr-7">
                          <v-flex xs6 sm6 md6>
                            <v-text-field
                              v-model="item.concepto"
                              label="Concepto"
                              disabled
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm6 md6>
                            <v-text-field
                              v-model="item.cantidad"
                              type="number"
                              min="0"
                              label="Cantidad"
                              disabled
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-textarea
                              v-model="item.expecificaciones"
                              label="Expecificaciones"
                              disabled
                            ></v-textarea>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-textarea
                              v-model="item.observaciones"
                              label="Argumento para la compra"
                              disabled
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn elevation="2" color="#f7e506" @click="close"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
              </v-card>
            </v-dialog>
          </v-toolbar>
          <br />
          <v-col cols="12" class="ma-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar Proceso"
              class="text-field"
              single-line
              color="#111c3d"
            ></v-text-field>
          </v-col>
          <br />
          <v-col cols="12" class="ma-0">
            <v-data-table
              :headers="headers"
              :items="apps"
              :search="search"
              style="border: 2px solid #111c3d"
              class="elevation-3"
            >
              <!-- tabla donde se pintan los datos obtenidos del arreglo -->
              <template v-slot:no-data>
                <v-alert
                  :value="true"
                  color="#EF5350"
                  icon="mdi-alert"
                  outlined
                  type="warning"
                  prominent
                  border="left"
                >
                  <strong>No</strong> se encontro su busqueda
                </v-alert>
              </template>
              <!--acciones-->
              <template v-slot:[`item.actions`]="{ item }">
                <!-- icono check-->
                <v-icon class="mr-2" color="green" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#601ae4"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#601ae4" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      apps: [],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      headers: [
        {
          text: "ID proceso",
          value: "idProceso",
          align: "center",
          class: "column",
        },
        {
          text: "Area",
          value: "nombreArea",
          align: "center",
          class: "column",
        },
        {
          text: "Director area",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha",
          value: "fechaCreacion",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        id: "",
        Concepto: "",
        cantidad: "",
        Especificacion: "",
        Observaciones: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        Concepto: "",
        cantidad: "",
        Especificacion: "",
        Observaciones: "",
        infoProceso: {
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Proceso" : "Editar Aplicacion";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerApps();
  },

  methods: {
    // Metodo para obtener las aplicaciones
    obtenerApps() {
      axios
        .get(`${env.endpoint}user/procesosGerente `)
        .then((res) => (this.apps = res.data));
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.apps.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log();
      this.dialog = true;
      // console.log(item);
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    //metodo para eliminado de  procesos
    // deleteItem(item) {
    //   swal({
    //     title: "Este registro sera eliminado permanentemente.",
    //     text: "Una vez eliminado no se podra recuperar.",
    //     icon: "warning",
    //     buttons: ["Cancelar", true],
    //     dangerMode: true,
    //   }).then((willDelete) => {
    //     if (willDelete) {
    //       axios
    //         .get(`${env.endpoint}user/delete_proceso?idProceso=${item.idProceso}`)
    //         .then((res) => {
    //           swal("Registro eliminado con exito!", {
    //             icon: "success",
    //           });
    //         })
    //         .then((otherProcess) => {
    //           this.obtenerApps();
    //         })
    //         .catch((error) => {
    //           this.text =
    //             "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
    //         });
    //     } else {
    //       swal("Proceso de eliminacion cancelado");
    //     }
    //   });
    // },

    /**
     * Metodo para actualizar procesos
     */
    // save() {
    //   if (this.editedIndex > -1) {
    //     // obtiene los datos del arreglo para poder actualizar el usuario en el modal
    //     // se seta los datos obtenidos del arreglo par modificarlo
    //     const proceso= this.editedItem;
    //     const infoProcesos = JSON.stringify(this.editedItem.infoProceso)
    //     axios
    //       .get(`${env.endpoint}user/modificar_procesos_gerente?info=${infoProcesos}&idProceso=${proceso.idProceso}`)
    //       .then((res) => {
    //         if (res.data === true) {
    //           (this.snackbar = true),
    //             (this.text = "Proceso enviado satisfactoriamente");
    //             this.close();
    //             this.obtenerApps();
    //         } else if (res.data === false) {
    //           (this.snackbar = true), (this.text = "Error en el envio");
    //           this.close();
    //         }

    //       });
    //       this.close();
    //       this.obtenerApps();
    //   }
    // },
  },
};
</script>
